import { z } from 'zod';

// the suggestion object schema
//  each suggestion object contains a word, a definition and a rank
export const suggestionSchema = z.strictObject({
  //  the suggested word
  word: z.string(),
  //  the definition of the suggested word
  definition: z.string().nullable(), //.required().allow('', null),
  //  rank provided to enable the client to display the suggestions with the most relevant (lowest rank) first
  //  when token.state is checked, spellings is present, rank can be optional because it will be re-sorted
  rank: z.number().int().min(0).nullable().optional(), //allow(null).optional(),
});

export type suggestionDTO = z.infer<typeof suggestionSchema>;

export class Suggestion {
  constructor(public readonly dto: suggestionDTO) {}

  // Factory methods
  static fromDTO(dto: suggestionDTO): Suggestion {
    suggestionSchema.parse(dto);
    return new Suggestion(dto);
  }
}
